import { currentColorSchemeAtom, type ColorSchemeValue } from "@/modules/main/ColorSchemeSwitcher.store.ts";
import { colorSchemeAttribute } from "@/modules/theme/shared.ts";
import { useAtomValue } from "jotai/react";
import { getDefaultStore } from "jotai/vanilla";
import { useLayoutEffect } from "react";

/** Applies the global color scheme attributes to the HTML */
export function ColorSchemeSwitcher() {
    // Only supports global store
    const currentScheme = useAtomValue(currentColorSchemeAtom, { store: getDefaultStore() });

    useLayoutEffect(() => {
        setColorSchemeAttribute(currentScheme);
    }, [currentScheme]);

    return null;
}

function setColorSchemeAttribute(theme: ColorSchemeValue) {
    const el = document.documentElement;
    if (el.getAttribute(colorSchemeAttribute) === theme) {
        return;
    }
    console.debug("Setting color scheme attribute to: %o", theme);
    el.setAttribute(colorSchemeAttribute, theme);
}
